import type { TeacherWorkload } from 'shared/api';
import type { TeacherWorkloadTableRow } from '../types';

export const mapQualificationsToRows = (
  teacherWorkload: TeacherWorkload,
): TeacherWorkloadTableRow[] =>
  teacherWorkload.qualifications.map((q, index) => ({
    key: `${teacherWorkload.id}-${index}`,
    subjectId: q.subjectId,
    workloadHours: q.workloadHours,
    educationalClasses: q.educationalClassIds ?? [],
  }));
